import React from "react";
import styles from "../AccessForm/AccessForm.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
const TaskList = ({
  navItems,
  selectedNavItem,
  onNavItemSelect,
  onDeleteClick,
  tasksLoading,
}) => {
  return (
    <div className={styles.left}>
      <div className={styles.leftHeader}>
        <h3>Tasks</h3>
      </div>
      <div className={styles.navItemsContainer}>
        <div className={styles.navItems}>
          {tasksLoading ? (
            <Skeleton count={4} height={45} width={"100%"} />
          ) : (
            navItems.map((item, index) => (
              <div
                key={index}
                className={`
                ${styles.navItem} 
                ${
                  selectedNavItem?.title === item?.title
                    ? styles.selectedNavItem
                    : ""
                }
              `}
                onClick={() => onNavItemSelect(item)}
              >
                <span className={styles.navItemText}>{item?.title}</span>
                <FontAwesomeIcon
                  icon={faTrash}
                  className={styles.deleteIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteClick(item?.task);
                  }}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskList;
